export const ADMIN_DATA = 'ADMIN_DATA';
